module.exports = __webpack_public_path__ + "static/media/viewingContact.c3fa31ab.png";